import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { FrenchPhoneRegEx } from "../../helpers/schemas";
export var phoneNumberField = new SimpleSchema({
    number: {
        type: String,
        regEx: FrenchPhoneRegEx
    },
    verified: {
        type: Boolean
    },
    updatedAt: {
        type: Date,
        optional: true
    },
    verifyToken: {
        type: String,
        optional: true
    }
});
